var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rentabilidade-component" },
    [
      _c("v-card", { staticClass: "grafico-wrapper", attrs: { flat: "" } }, [
        _c("div", { staticClass: "grafico-desempenho" }, [
          _c("div", { staticClass: "top-grafico" }, [
            _c("div", { staticClass: "top" }, [
              _c("div", { staticClass: "title-grafico" }, [
                _c("span", [_vm._v("Rentabilidade da carteira")])
              ]),
              _c("div", { staticClass: "btns-ativos" }, [
                _c(
                  "div",
                  { staticClass: "btn-cdi" },
                  [
                    _c("v-switch", {
                      attrs: { label: "CDI", bgColor: "#35BAFC" },
                      on: {
                        click: function($event) {
                          return _vm.switchChanged("CDI")
                        }
                      },
                      model: {
                        value: _vm.stateCDI,
                        callback: function($$v) {
                          _vm.stateCDI = $$v
                        },
                        expression: "stateCDI"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "btn-ipca" },
                  [
                    _c("v-switch", {
                      attrs: { label: "IPCA", bgColor: "#29BD1A" },
                      on: {
                        click: function($event) {
                          return _vm.switchChanged("IPCA")
                        }
                      },
                      model: {
                        value: _vm.stateIPCA,
                        callback: function($$v) {
                          _vm.stateIPCA = $$v
                        },
                        expression: "stateIPCA"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "btn-dolar" },
                  [
                    _c("v-switch", {
                      attrs: { label: "DÓLAR", bgColor: "#C520FF" },
                      on: {
                        click: function($event) {
                          return _vm.switchChanged("DOLAR")
                        }
                      },
                      model: {
                        value: _vm.stateDolar,
                        callback: function($$v) {
                          _vm.stateDolar = $$v
                        },
                        expression: "stateDolar"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "btn-ibovespa" },
                  [
                    _c("v-switch", {
                      attrs: { label: "IBOVESPA", bgColor: "#FA5807" },
                      on: {
                        click: function($event) {
                          return _vm.switchChanged("IBOVESPA")
                        }
                      },
                      model: {
                        value: _vm.stateIBovespa,
                        callback: function($$v) {
                          _vm.stateIBovespa = $$v
                        },
                        expression: "stateIBovespa"
                      }
                    })
                  ],
                  1
                )
              ])
            ])
          ]),
          _c(
            "div",
            { staticClass: "grafico" },
            [
              _c("Bar", {
                attrs: {
                  chartData: _vm.testeObj,
                  options: _vm.options,
                  label: "Carteira",
                  label2: "Rentabilidade mensal"
                }
              }),
              _c("div", { staticClass: "descricao-grafico" }, [
                _c("span", [_vm._v("Rentabilidade (%)")])
              ])
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }